import React, { useEffect, useRef } from "react";
import OurVision_img from "../../assets/images/webp/OurVision_img.jpg";
import { Link } from "react-router-dom";
import { tiltHandlers } from "./useTilt";
import "../../styles/animatica.css";

const OurVision = () => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const element = sectionRef.current;
    if (!element) return undefined;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          element.classList.add("an-visible");
          observer.disconnect();
        }
      },
      { threshold: 0.15 },
    );

    observer.observe(element);
    return () => observer.disconnect();
  }, []);

  return (
    <div ref={sectionRef} className="py-5 bg-gradient-to-b from-[#0a0a0a] via-[#0f172a] to-[#0a0a0a]">
      <div className="container">
        <div className="row align-items-center justify-content-between">
          <div className="col-md-5 an-reveal an-reveal-d1">
            <div className="an-img-wrap an-tilt" {...tiltHandlers}>
              <div className="an-img-inner">
                <img loading="lazy" decoding="async" className="w-100" src={OurVision_img} alt="OurVision_img" />
              </div>
              <div className="an-glass position-absolute px-4 py-3" style={{ bottom: "-22px", right: "-16px", zIndex: 3 }}>
                <h4 className="mb-0 fs_24 fw-bold ff_s" style={{ color: "#ef4444" }}>20+</h4>
                <p className="mb-0 fs_14 ff_n fw-semibold" style={{ color: "#f8fafc" }}>CoEs Planned</p>
              </div>
            </div>
          </div>
          <div className="col-md-7 ps-0 ps-md-5">
            <span className="an-reveal an-reveal-d2 an-eyebrow">
              Where We're Headed
            </span>
            <h3 className="an-reveal an-reveal-d2 fs_35 ff_s fw-bold text-white mb-0">
              Our <span className="text-white">Vision</span>
            </h3>
            <p className="an-reveal an-reveal-d3 fs_16 ff_n text_justify text-gray-300 mb-0 mt-4">
              Over the next two years, we aim to establish 20 ICASA
              Centers of Excellence, with 4 already in the pipeline. Each center
              will serve as a hub of innovation, creativity, and opportunity,
              empowering students and creators to shape the future of the
              AVGC-XR sector and film production.
            </p>
            <h3 className="an-reveal an-reveal-d4 fs_24 fw-semibold ff_n text-white mb-0 mt-4">
              Your Opportunity to Lead
            </h3>
            <p className="an-reveal an-reveal-d4 fs_16 ff_n text_justify text-gray-300 mb-0 mt-3">
              Become a franchise owner and contribute to shaping the digital
              landscape of India. Whether you’re an entrepreneur, an investor,
              or an academic visionary, ICASA offers a platform where
              innovation meets profitability.
            </p>
            <p className="an-reveal an-reveal-d5 fs_16 ff_n text_justify text-gray-300 mb-0 mt-4">
              Ready to Transform the Industry? Let’s Talk! Take the first step
              toward owning an ICASA franchise by filling out the
              inquiry form below.
            </p>
            <Link to={"/contact-us"}>
              <button className="an-reveal an-reveal-d5 an-btn cummon_btn border-0 fs_14 fw-bold ff_s text-white px-4 mt-4 py-2 rounded-2">
                Let’s Talk
              </button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OurVision;
